import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_6 = {
  key: 0,
  class: "description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["FontAwesomeIcon"], {
          class: "icon",
          icon: $props.icon
        }, null, 8 /* PROPS */, ["icon"]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { style: {"width":"12px"} }, null, -1 /* HOISTED */)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString($props.title), 1 /* TEXT */),
            _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"width":"4px"} }, null, -1 /* HOISTED */)),
            ($props.subtitle)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "(" + _toDisplayString($props.subtitle) + ")", 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          ($props.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.description), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createVNode($setup["CommonSwitch"], {
        value: $props.isEnabled,
        onChange: _cache[0] || (_cache[0] = (value) => {
          $setup.emit('set-is-enabled', value);
        })
      }, null, 8 /* PROPS */, ["value"])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"height":"8px"} }, null, -1 /* HOISTED */)),
    _createVNode($setup["CommonInput"], {
      modelValue: $props.value,
      icon: $props.inputIcon,
      "supporting-text": $props.errorText,
      label: "Valor do benefício",
      mask: $setup.FormatUtils.formatMoney($props.value, true),
      state: $setup.getState(),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (e) => {
        _ctx.$emit('change', e, $props.isEnabled);
      }),
      onTapTrailing: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change', '', $props.isEnabled)))
    }, null, 8 /* PROPS */, ["modelValue", "icon", "supporting-text", "mask", "state"])
  ]))
}